import React from 'react';
import { XIcon } from '../../icons';
var MuiChip = {
    /* put your new default props here */
    deleteIcon: React.createElement(XIcon, { fontSize: "inherit", style: { width: '16px' } }),
};
export default MuiChip;
//# sourceMappingURL=MuiChip.js.map